import { Audience as AudienceAPI, Segment as SegmentAPI } from '@occc-app/Activate/apiTypes';

import { Audiences as AudiencesClient, AudienceKeys, Segment as SegmentClient } from './types';

type DeserializeAudienceType = (
  audienceType: AudienceAPI['attributes']['audience_type'],
) => AudienceKeys;
export const deserializeAudienceType: DeserializeAudienceType = (audienceType) => {
  switch (audienceType) {
    case 'age_within':
      return 'ageWithin';
    case 'in_all_segments':
      return 'inAllSegments';
    case 'in_any_segments':
      return 'inAnySegments';
    default:
      throw new Error('Unsupported audienceType');
  }
};

type DeserializeAudience = (audienceBody: AudienceAPI) => AudiencesClient;
export const deserializeAudience: DeserializeAudience = (audienceBody) => {
  switch (audienceBody.attributes.audience_type) {
    case 'age_within':
      return {
        active: true,
        type: 'ageWithin',
        maximumAge: audienceBody.attributes.configuration.maximum_age || '',
        maximumAgeActive: !!audienceBody.attributes.configuration.maximum_age,
        minimumAge: audienceBody.attributes.configuration.minimum_age || '',
        minimumAgeActive: !!audienceBody.attributes.configuration.minimum_age,
      };
    case 'in_all_segments':
      return {
        active: true,
        type: 'inAllSegments',
        segments: audienceBody.attributes.configuration.segment_ids,
      };
    case 'in_any_segments':
      return {
        active: true,
        type: 'inAnySegments',
        segments: audienceBody.attributes.configuration.segment_ids,
      };
    default:
      throw new Error('Unsupported audienceType');
  }
};

type DeserializeSegments = (segmentsBody: SegmentAPI[]) => SegmentClient[];
export const deserializeSegments: DeserializeSegments = (segmentsBody) => {
  return segmentsBody.map((segmentAPI) => ({
    id: segmentAPI.id,
    name: segmentAPI.attributes.name,
  }));
};
